import { render, staticRenderFns } from "./Outsourcing.vue?vue&type=template&id=6d88d800&scoped=true&"
import script from "./Outsourcing.vue?vue&type=script&setup=true&lang=js&"
export * from "./Outsourcing.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88d800",
  null
  
)

export default component.exports